
<div class="select-filter fds">
  <t-row class="filter pt-1 pb-2">
    <t-column class="row-title d-flex flex-row align-items-center justify-content-start" size="100%">
      <prefix class="mt-1 mr-2">
        <input
          type="checkbox"
          :checked="allFilteredEntriesSelected || allSeenEntriesSelected"
          @input="setSelectAllSeenEntries"
          id="select-all-entries-checkbox"
        >
        <label for="select-all-entries-checkbox" class="sr-only">Select All Entries</label>
      </prefix>
      <p class="mr-3 flex-shrink-0" v-if="allFilteredEntriesSelected">
        All Filtered Entries selected
      </p>
      <p class="mr-3 flex-shrink-0" v-else>
        {{ 'row' | pluralize(selectedEntries.length)}} selected
      </p>
      <div class="dropdown mr-3">
        <button class="dropdown-toggle arrow btn xs action-btn green bulk-workflow-actions-options"
                data-toggle="dropdown"
                aria-haspopup="true"
                id="bulkActions"
                aria-expanded="false"
                :disabled="isDisabled">
          Actions
        </button>
        <ul class="dropdown-menu" aria-labelledby="bulkActions">
          <li v-if="selectedEntries.length > 0 || allFilteredEntriesSelected ">
            <button v-for="action in availableBulkActions" class="dropdown-item" :key="action.id" @click="actionRequested(action)">
              {{action.label_title || "(Untitled Action)"}}
            </button>
            <button @click="deselectAllEntries" class="dropdown-item">Deselect All</button>
          </li>
        </ul>
      </div>
      <div v-if="allSeenEntriesSelected && !allFilteredEntriesSelected">
        <div>
          All {{selectedEntries.length}} visible entries on this page are selected.
          <a @click="setSelectAllFilteredEntries" class="btn-link">
            Select all entries that match this filter.
          </a>
        </div>
      </div>
    </t-column>
  </t-row>

  <object-model-action-custom-notification
    bulk
    :state="modalStateFor(vueModalID.objectModelActionCustomNotification)"
    :index="vueModalID.objectModelActionCustomNotification"
    @toggle-modal="hideCustomNotificationModal"
    @send="notificationComposed($event)"
  />

  <confirmation-modal
    v-if="modalStateFor(vueModalID.confirmation).isVisible"
    :state="modalStateFor(vueModalID.confirmation)"
    @toggle-modal="confirmationModalToggled"
    :overrideConfig="confirmationModalConfig"
  />
</div>
